import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "title-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.0755 9.00012C8.6719 9.00012 8.34473 9.3273 8.34473 9.73089C8.34473 10.1345 8.6719 10.4617 9.0755 10.4617H11.2678V15.0899C11.2678 15.4935 11.595 15.8206 11.9986 15.8206C12.4022 15.8206 12.7293 15.4935 12.7293 15.0899V10.4617H14.9216C15.3252 10.4617 15.6524 10.1345 15.6524 9.73089C15.6524 9.3273 15.3252 9.00012 14.9216 9.00012H9.0755Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 2.25012C4.82436 2.25012 2.25 4.82448 2.25 8.00012V16.0001C2.25 19.1758 4.82436 21.7501 8 21.7501H16C19.1756 21.7501 21.75 19.1758 21.75 16.0001V8.00012C21.75 4.82448 19.1756 2.25012 16 2.25012H8ZM3.75 8.00012C3.75 5.65291 5.65279 3.75012 8 3.75012H16C18.3472 3.75012 20.25 5.65291 20.25 8.00012V16.0001C20.25 18.3473 18.3472 20.2501 16 20.2501H8C5.65279 20.2501 3.75 18.3473 3.75 16.0001V8.00012Z"
    }, null, -1)
  ])))
}
export default { render: render }